module.exports = __webpack_public_path__ + "static/img/carousel_4_ur2nwj_ar_16_9_w_2400.8710ea8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_4_ur2nwj_ar_16_9_w_2400.jpg
// module id = YEUo
// module chunks = 0